/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type FieldValueType = typeof FieldValueType[keyof typeof FieldValueType];


export const FieldValueType = {
  Text: 'Text',
  ImageDataURI: 'ImageDataURI',
} as const;
